/**
 * Bestillingslenker for Oscars Pizzeria
 * Meny og bestilling: Ninito (primær) og Foodora (levering)
 */
export const ORDER_LINKS = {
  ninito: 'https://order.ninito.com/no/group/oscars-pizzeria/holter',
  foodora: 'https://www.foodora.no/restaurant/n1sj/oscars-pizzeria',
};
